export default {
  title: 'Updates',
  fields: {
    app_version: 'App Version',
    description: 'Description',
    created_at: 'Created At',
  },
};
